export default __webpack_public_path__ + "static/media/openfinance.098d984c.svg";